import './style.scss';

const Calculator = () => {
  return (
    <div className='box'>
      <div className='group'>
        <div className='overlap'>
          <div className='overlap-group'>
            <div className='rectangle' />
            <div className='inputTextCalculator'>124,98 zł</div>
            <div className='frame'>
              <p className='text-wrapper'>Do zapłaty w ciągu 45 dni</p>
            </div>
            <div className='frame2'>
              <div className='text-wrapper'>W tym koszt prowizji</div>
            </div>
            <div className='group-2'>
              <div className='overlap-2'>
                <svg width='156' height='56' viewBox='0 0 156 56' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H150C153.038 0.5 155.5 2.96243 155.5 6V50C155.5 53.0376 153.038 55.5 150 55.5H6C2.96244 55.5 0.5 53.0376 0.5 50V6Z'
                    fill='white'
                    stroke='var(--calculatorprimaryColor)'
                  />
                </svg>

                <div className='input-text-2'>45</div>
                <div className='input-text-3'>dni</div>
              </div>
              <div className='input-text-4'>14 dni</div>
              <p className='p'>
                Symulacja ma charakter informacyjny i nie stanowi oferty w rozumieniu art. 66 par. 1 KC.
                <br />
                Wyliczenia kalkulatora służą do celów informacyjnych.
              </p>
              <div className='input-text-5'>21 dni</div>
              <div className='input-text-6'>30 dni</div>
              <div className='input-text-7'>45 dni</div>
              <div className='input-text-8'>60 dni</div>
            </div>
            <div className='input-text-9'>2 724,98 zł</div>
            <div className='rectangle3' />
            <div className='rectangle-4' />
            <div className='rectangle-5' />
            <div className='rectangle-6' />
            <div className='rectangle-7' />
            <div className='rectangle-8' />
            <div className='rectangle-9' />
            <div className='rectangle-10' />
            <div className='rectangle-11' />
          </div>
          <div className='overlap-3'>
            <div className='group-3'>
              <div className='overlap-group-2'>
                <svg width='156' height='56' viewBox='0 0 156 56' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H150C153.038 0.5 155.5 2.96243 155.5 6V50C155.5 53.0376 153.038 55.5 150 55.5H6C2.96244 55.5 0.5 53.0376 0.5 50V6Z'
                    fill='white'
                    stroke='var(--calculatorprimaryColor)'
                  />
                </svg>

                <div className='input-text-2'>2 600,00</div>
                <div className='input-text-10'>zł</div>
              </div>
              <div className='input-text-4'>min. 100 zł</div>
              <div className='input-text-11'>max. 50 000 zł</div>
            </div>
            <div className='rectangle-12' />
            <div className='rectangle-13' />
            <div className='rectangle-14' />
            <div className='rectangle15' />
          </div>
          <div className='input-text-wrapper'>
            <div className='text-wrapper'>Wartość zakupu</div>
          </div>
          <div className='div-wrapper'>
            <div className='text-wrapper'>Liczba dni na spłatę</div>
          </div>
          <div className='frame-wrapper'>
            <div className='frame-3'>
              <div className='input-text-12'>Dopasuj swoją ofertę</div>
            </div>
          </div>
          <div className='frame-4'>
            <div className='group-4'>
              <div className='frame-5'>
                <div className='input-text-13'>Odroczona płatność</div>
              </div>
            </div>
            <div className='frame6'>
              <div className='input-text-14'>Raty</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calculator;
